import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { generateXraySpineDorsalReport } from '../../utils/xrayspinedorsal';
import { API_BASE_URL } from '../Api/apiconnector';

export default function XRaySpineDorsalForm({ onClose, generateReport, currentUser }) {
  const [formData, setFormData] = useState({
    // Demographics - using the same field names as the report generator expects
    NameTextFR10: '',
    IDTextFR10: '',
    AgeTextFR10: '',
    TestDateTextFR10: '',
    ReportDateTextFR10: '',
    GenderTextFR10: '',
    ReferralDrTextFR10: '',
    ReporttimeTextFR10: '',
    
    // Form fields - using the exact field names expected by the report generator
    SpineView: 'AP',
    NormalSpine: false,
    CervicalDegenerative: false,
    CervicalFracture: false,
    CervicalSpondylolisthesis: false,
    CervicalFacetJointDislocationFrature: false,
    CerivicalOsteopenia: false,
    CervicalCollapse: false,
    
    // Lordosis
    cervicalLordosis: false,
    cervicalLordosisType: '',
    
    // Osteophytes
    CervicalOsteophytes: false,
    CervicalOsteophytesC1: false, CervicalOsteophytesC2: false, CervicalOsteophytesC3: false,
    CervicalOsteophytesC4: false, CervicalOsteophytesC5: false, CervicalOsteophytesC6: false,
    CervicalOsteophytesC7: false, CervicalOsteophytesC8: false, CervicalOsteophytesC9: false,
    CervicalOsteophytesC10: false, CervicalOsteophytesC11: false, CervicalOsteophytesC12: false,
    
    // Endplate Sclerosis
    CervicalEndplateSclerosis: false,
    CervicalEndplateSclerosisC1: false, CervicalEndplateSclerosisC2: false, CervicalEndplateSclerosisC3: false,
    CervicalEndplateSclerosisC4: false, CervicalEndplateSclerosisC5: false, CervicalEndplateSclerosisC6: false,
    CervicalEndplateSclerosisC7: false, CervicalEndplateSclerosisC8: false, CervicalEndplateSclerosisC9: false,
    CervicalEndplateSclerosisC10: false, CervicalEndplateSclerosisC11: false, CervicalEndplateSclerosisC12: false,
    
    // Vacuum Phenomenon
    CervicalVacuumPhenomenon: false,
    CervicalVacuumPhenomenonC1: false, CervicalVacuumPhenomenonC2: false, CervicalVacuumPhenomenonC3: false,
    CervicalVacuumPhenomenonC4: false, CervicalVacuumPhenomenonC5: false, CervicalVacuumPhenomenonC6: false,
    CervicalVacuumPhenomenonC7: false, CervicalVacuumPhenomenonC8: false, CervicalVacuumPhenomenonC9: false,
    CervicalVacuumPhenomenonC10: false, CervicalVacuumPhenomenonC11: false, CervicalVacuumPhenomenonC12: false,
    
    // Schmorl's Nodes
    CervicalSchmorlsNode: false,
    CervicalSchmorlsNodeC1: false, CervicalSchmorlsNodeC2: false, CervicalSchmorlsNodeC3: false,
    CervicalSchmorlsNodeC4: false, CervicalSchmorlsNodeC5: false, CervicalSchmorlsNodeC6: false,
    CervicalSchmorlsNodeC7: false, CervicalSchmorlsNodeC8: false, CervicalSchmorlsNodeC9: false,
    CervicalSchmorlsNodeC10: false, CervicalSchmorlsNodeC11: false, CervicalSchmorlsNodeC12: false,
    
    // Intervertebral Disc Space
    CervicalInterVertebralDiscSpace: false,
    CervicalInterVertebralDiscSpaceC1C2: false, CervicalInterVertebralDiscSpaceC2C3: false,
    CervicalInterVertebralDiscSpaceC3C4: false, CervicalInterVertebralDiscSpaceC4C5: false,
    CervicalInterVertebralDiscSpaceC5C6: false, CervicalInterVertebralDiscSpaceC6C7: false,
    CervicalInterVertebralDiscSpaceC7C8: false, CervicalInterVertebralDiscSpaceC8C9: false,
    CervicalInterVertebralDiscSpaceC9C10: false, CervicalInterVertebralDiscSpaceC10C11: false,
    CervicalInterVertebralDiscSpaceC11C12: false,
    
    // Fractures
    CervicalCompressionFracture: false,
    CervicalRetropulsion1: false,
    CervicalCompressionFractureC1: false, CervicalCompressionFractureC2: false, CervicalCompressionFractureC3: false,
    CervicalCompressionFractureC4: false, CervicalCompressionFractureC5: false, CervicalCompressionFractureC6: false,
    CervicalCompressionFractureC7: false, CervicalCompressionFractureC8: false, CervicalCompressionFractureC9: false,
    CervicalCompressionFractureC10: false, CervicalCompressionFractureC11: false, CervicalCompressionFractureC12: false,
    CervicalCompressionFractureL1: false,
    
    CervicalBurstFracture: false,
    CervicalRetropulsion2: false,
    CervicalBurstFractureC1: false, CervicalBurstFractureC2: false, CervicalBurstFractureC3: false,
    CervicalBurstFractureC4: false, CervicalBurstFractureC5: false, CervicalBurstFractureC6: false,
    CervicalBurstFractureC7: false, CervicalBurstFractureC8: false, CervicalBurstFractureC9: false,
    CervicalBurstFractureC10: false, CervicalBurstFractureC11: false, CervicalBurstFractureC12: false,
    CervicalBurstFractureL1: false,
    
    CervicalChanceFracture: false,
    CervicalRetropulsion3: false,
    CervicalChanceFractureC1: false, CervicalChanceFractureC2: false, CervicalChanceFractureC3: false,
    CervicalChanceFractureC4: false, CervicalChanceFractureC5: false, CervicalChanceFractureC6: false,
    CervicalChanceFractureC7: false, CervicalChanceFractureC8: false, CervicalChanceFractureC9: false,
    CervicalChanceFractureC10: false, CervicalChanceFractureC11: false, CervicalChanceFractureC12: false,
    CervicalChanceFractureL1: false,
    
    CervicalFlexionTearDropFracture: false,
    CervicalFlexionTearDropFractureC1: false, CervicalFlexionTearDropFractureC2: false, CervicalFlexionTearDropFractureC3: false,
    CervicalFlexionTearDropFractureC4: false, CervicalFlexionTearDropFractureC5: false, CervicalFlexionTearDropFractureC6: false,
    CervicalFlexionTearDropFractureC7: false, CervicalFlexionTearDropFractureC8: false, CervicalFlexionTearDropFractureC9: false,
    CervicalFlexionTearDropFractureC10: false, CervicalFlexionTearDropFractureC11: false, CervicalFlexionTearDropFractureC12: false,
    CervicalFlexionTearDropFractureL1: false,
    
    CervicalExtensionTearDropFracture: false,
    CervicalExtensionTearDropFractureC1: false, CervicalExtensionTearDropFractureC2: false, CervicalExtensionTearDropFractureC3: false,
    CervicalExtensionTearDropFractureC4: false, CervicalExtensionTearDropFractureC5: false, CervicalExtensionTearDropFractureC6: false,
    CervicalExtensionTearDropFractureC7: false, CervicalExtensionTearDropFractureC8: false, CervicalExtensionTearDropFractureC9: false,
    CervicalExtensionTearDropFractureC10: false, CervicalExtensionTearDropFractureC11: false, CervicalExtensionTearDropFractureC12: false,
    CervicalExtensionTearDropFractureL1: false,
    
    CervicalDonsFrature: false,
    CervicalDonsFratureType: '',
    
    CervicalSpinousProcessFracture: false,
    CervicalSpinousProcessFractureC1: false, CervicalSpinousProcessFractureC2: false, CervicalSpinousProcessFractureC3: false,
    CervicalSpinousProcessFractureC4: false, CervicalSpinousProcessFractureC5: false, CervicalSpinousProcessFractureC6: false,
    CervicalSpinousProcessFractureC7: false, CervicalSpinousProcessFractureC8: false, CervicalSpinousProcessFractureC9: false,
    CervicalSpinousProcessFractureC10: false, CervicalSpinousProcessFractureC11: false, CervicalSpinousProcessFractureC12: false,
    CervicalSpinousProcessFractureL1: false,
    
    // Spondylolisthesis
    CervicalretrolisthesisOf: false,
    CervicalretrolisthesisOfC1: false, CervicalretrolisthesisOfC2: false, CervicalretrolisthesisOfC3: false,
    CervicalretrolisthesisOfC4: false, CervicalretrolisthesisOfC5: false, CervicalretrolisthesisOfC6: false,
    CervicalretrolisthesisOfC7: false, CervicalretrolisthesisOfC8: false, CervicalretrolisthesisOfC9: false,
    CervicalretrolisthesisOfC10: false, CervicalretrolisthesisOfC11: false,
    RetroSpondylosis: false,
    
    CervicalanterolisthesisOf: false,
    CervicalanterolisthesisOfC1: false, CervicalanterolisthesisOfC2: false, CervicalanterolisthesisOfC3: false,
    CervicalanterolisthesisOfC4: false, CervicalanterolisthesisOfC5: false, CervicalanterolisthesisOfC6: false,
    CervicalanterolisthesisOfC7: false, CervicalanterolisthesisOfC8: false, CervicalanterolisthesisOfC9: false,
    CervicalanterolisthesisOfC10: false, CervicalanterolisthesisOfC11: false,
    AntroSpondylosis: false,
    
    // Facet Joint Dislocation
    CervicalFacetJointDislocationFratureType: '',
    CervicalFacetJointDislocationFratureC1: false, CervicalFacetJointDislocationFratureC2: false, CervicalFacetJointDislocationFratureC3: false,
    CervicalFacetJointDislocationFratureC4: false, CervicalFacetJointDislocationFratureC5: false, CervicalFacetJointDislocationFratureC6: false,
    CervicalFacetJointDislocationFratureC7: false, CervicalFacetJointDislocationFratureC8: false, CervicalFacetJointDislocationFratureC9: false,
    CervicalFacetJointDislocationFratureC10: false, CervicalFacetJointDislocationFratureC11: false, CervicalFacetJointDislocationFratureC12: false,
    
    // Collapse
    CervicalCollapseC1: false, CervicalCollapseC2: false, CervicalCollapseC3: false,
    CervicalCollapseC4: false, CervicalCollapseC5: false, CervicalCollapseC6: false,
    CervicalCollapseC7: false, CervicalCollapseC8: false, CervicalCollapseC9: false,
    CervicalCollapseC10: false, CervicalCollapseC11: false, CervicalCollapseC12: false,
    
    // Additional findings
    CervicalText: ''
  });

  // Fetch demographics on component mount
  useEffect(() => {
    const fetchDemographics = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const patientId = urlParams.get("id");
        if (!patientId) return;

        const response = await fetch(`${API_BASE_URL}/fetch-dicom/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ id: patientId }),
        });

        if (!response.ok) throw new Error(`Failed to fetch demographics (${response.status})`);
        const data = await response.json();
        console.log("✅ Fetched demographics:", data);

        const formattedStudyDate = data.study_date || "";
        const now = new Date();
        const formattedReportDate = formatToDDMMYYYY(now);
        const formattedReportTime = formatToHHMM(now);

        setFormData((prev) => ({
          ...prev,
          NameTextFR14: data.patient_name || "",
          IDTextFR14: data.patient_id || "",
          AgeTextFR14: data.age || "",
          GenderTextFR14: data.gender || "Male",
          TestDateTextFR14: formattedStudyDate,
          ReportDateTextFR14: formattedReportDate,
          ReferralDrTextFR14: data.referring_physician || "",
          ReporttimeTextFR14: formattedReportTime,
        }));
      } catch (error) {
        console.error("❌ Error fetching DICOM demographics:", error);
      }
    };
    fetchDemographics();
  }, []);

  function formatToHHMM(date) {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  function formatToDDMMYYYY(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Remove the mapFormDataToReportFormat function since we're using the exact field names now

  const handleBack = () => {
    console.log('Back clicked');
    if (onClose) {
      onClose();
    }
  };

  const handleDone = () => {
    console.log('Form submitted:', formData);
    // Pass formData directly since we're using the exact field names expected by the report generator
    const report = generateXraySpineDorsalReport(formData, currentUser);
    console.log('Generated Report:', report);
    
    if (generateReport) {
      generateReport(report);
    }
    
    console.log("✅ Report generated and sent to editor", report);
    alert('Form submitted successfully! Report generated in editor.');
    
    if (onClose) {
      onClose();
    }
  };

  const handleReject = () => {
    console.log('Form rejected');
    alert('Form rejected!');
    if (onClose) {
      onClose();
    }
  };

  const handleCheckboxChange = (field) => {
    setFormData(prev => ({ ...prev, [field]: !prev[field] }));
  };

  const handleRadioChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Helper function to render vertebra checkboxes
  const renderVertebraCheckboxes = (prefix, levels) => {
    return (
      <div className="grid grid-cols-3 gap-2 ml-4 mt-2">
        {levels.map(level => (
          <label key={level} className="flex items-center gap-2 cursor-pointer">
            <input 
              type="checkbox" 
              checked={formData[`${prefix}${level}`] || false} 
              onChange={() => handleCheckboxChange(`${prefix}${level}`)} 
              className="w-4 h-4 accent-blue-600" 
            />
            <span className="text-sm text-gray-700">{level}</span>
          </label>
        ))}
      </div>
    );
  };

  // Helper function to render disc space checkboxes
  const renderDiscSpaceCheckboxes = (prefix, levels) => {
    return (
      <div className="grid grid-cols-2 gap-2 ml-4 mt-2">
        {levels.map(level => (
          <label key={level} className="flex items-center gap-2 cursor-pointer">
            <input 
              type="checkbox" 
              checked={formData[`${prefix}${level}`] || false} 
              onChange={() => handleCheckboxChange(`${prefix}${level}`)} 
              className="w-4 h-4 accent-blue-600" 
            />
            <span className="text-sm text-gray-700">{level.replace('C', 'D').replace('T', 'D')}</span>
          </label>
        ))}
      </div>
    );
  };

  const vertebralLevels = ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10', 'C11', 'C12'];
  const discLevels = ['C1C2', 'C2C3', 'C3C4', 'C4C5', 'C5C6', 'C6C7', 'C7C8', 'C8C9', 'C9C10', 'C10C11', 'C11C12'];
  const fractureLevels = [...vertebralLevels, 'L1'];
  const lordosisOptions = ['Maintained', 'Straightening', 'Exaggerated', 'Reversal'];
  const densFractureTypes = ['Type 1', 'Type 2', 'Type 3'];
  const facetJointTypes = ['Perched', 'Locked', 'Subluxation'];

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg flex flex-col" style={{ maxHeight: '90vh' }}>
        {/* Header */}
        <div className="flex-shrink-0 flex items-center justify-between p-4 border-b">
          <h1 className="text-xl font-bold">X-RAY SPINE (DORSAL)</h1>
          <div className="flex gap-2">
            <button onClick={handleBack} className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700">
              Back
            </button>
            <button onClick={handleDone} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
              Done
            </button>
            <button onClick={handleReject} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
              Reject
            </button>
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {/* Patient Info */}
          <div className="grid grid-cols-5 gap-4 text-sm mb-6">
            <div>
              <label className="block text-gray-600 mb-1">Name</label>
              <input type="text" value={formData.NameTextFR14} onChange={(e) => setFormData(prev => ({ ...prev, NameTextFR14: e.target.value }))} className="w-full px-3 py-2 border rounded" placeholder="Enter name" />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Patient ID</label>
              <input type="text" value={formData.IDTextFR14} onChange={(e) => setFormData(prev => ({ ...prev, IDTextFR14: e.target.value }))} className="w-full px-3 py-2 border rounded" placeholder="Enter ID" />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Age</label>
              <input type="text" value={formData.AgeTextFR14} onChange={(e) => setFormData(prev => ({ ...prev, AgeTextFR14: e.target.value }))} className="w-full px-3 py-2 border rounded" placeholder="Enter age" />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Test date</label>
              <input type="text" value={formData.TestDateTextFR14} onChange={(e) => setFormData(prev => ({ ...prev, TestDateTextFR14: e.target.value }))} className="w-full px-3 py-2 border rounded" placeholder="DD-MM-YYYY" />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Report date</label>
              <input type="text" value={formData.ReportDateTextFR14} onChange={(e) => setFormData(prev => ({ ...prev, ReportDateTextFR14: e.target.value }))} className="w-full px-3 py-2 border rounded" placeholder="DD-MM-YYYY" />
            </div>
          </div>

          {/* Gender */}
          <div className="mb-6">
            <div className="text-center text-gray-600 mb-2">Gender</div>
            <div className="flex justify-center gap-6">
              {['Male', 'Female', 'Others'].map(gender => (
                <label key={gender} className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="radio" 
                    checked={formData.GenderTextFR14 === gender} 
                    onChange={() => handleRadioChange('GenderTextFR14', gender)} 
                    className="w-4 h-4" 
                  />
                  <span>{gender}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Spine View */}
          <div className="mb-6">
            <div className="text-center text-gray-600 mb-2">Spine View</div>
            <div className="flex justify-center gap-6">
              {['AP', 'LATERAL', 'AP & LATERAL'].map(view => (
                <label key={view} className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="radio" 
                    checked={formData.SpineView === view} 
                    onChange={() => handleRadioChange('SpineView', view)} 
                    className="w-4 h-4" 
                  />
                  <span>{view}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Main Conditions */}
          <div className="space-y-4 mb-6">
            {/* Normal Spine */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input 
                type="checkbox" 
                checked={formData.NormalSpine} 
                onChange={() => handleCheckboxChange('NormalSpine')} 
                className="w-5 h-5 accent-blue-600" 
              />
              <span>Normal Spine Study?</span>
            </label>

            {/* Degenerative */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input 
                type="checkbox" 
                checked={formData.CervicalDegenerative} 
                onChange={() => handleCheckboxChange('CervicalDegenerative')} 
                className="w-5 h-5 accent-blue-600" 
              />
              <span>Degenerative?</span>
            </label>

            {formData.CervicalDegenerative && (
              <div className="ml-8 space-y-4 border-l-2 border-gray-200 pl-6">
                {/* Lordosis */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.cervicalLordosis} 
                    onChange={() => handleCheckboxChange('cervicalLordosis')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Lordosis?</span>
                </label>
                {formData.cervicalLordosis && (
                  <div className="ml-4 flex gap-6">
                    {lordosisOptions.map(type => (
                      <label key={type} className="flex items-center gap-2 cursor-pointer">
                        <input 
                          type="radio" 
                          checked={formData.cervicalLordosisType === type} 
                          onChange={() => handleRadioChange('cervicalLordosisType', type)} 
                          className="w-4 h-4" 
                        />
                        <span>{type}</span>
                      </label>
                    ))}
                  </div>
                )}

                {/* Osteophytes */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalOsteophytes} 
                    onChange={() => handleCheckboxChange('CervicalOsteophytes')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Osteophytes?</span>
                </label>
                {formData.CervicalOsteophytes && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalOsteophytes', vertebralLevels)}
                  </div>
                )}

                {/* Endplate Sclerosis */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalEndplateSclerosis} 
                    onChange={() => handleCheckboxChange('CervicalEndplateSclerosis')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Endplate Sclerosis?</span>
                </label>
                {formData.CervicalEndplateSclerosis && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalEndplateSclerosis', vertebralLevels)}
                  </div>
                )}

                {/* Vacuum Phenomenon */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalVacuumPhenomenon} 
                    onChange={() => handleCheckboxChange('CervicalVacuumPhenomenon')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Vacuum Phenomenon?</span>
                </label>
                {formData.CervicalVacuumPhenomenon && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalVacuumPhenomenon', vertebralLevels)}
                  </div>
                )}

                {/* Schmorl's Nodes */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalSchmorlsNode} 
                    onChange={() => handleCheckboxChange('CervicalSchmorlsNode')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Schmorl's nodes?</span>
                </label>
                {formData.CervicalSchmorlsNode && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalSchmorlsNode', vertebralLevels)}
                  </div>
                )}

                {/* Reduced Intervertebral Disc Space */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalInterVertebralDiscSpace} 
                    onChange={() => handleCheckboxChange('CervicalInterVertebralDiscSpace')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Reduced Inter Vertebral disc space?</span>
                </label>
                {formData.CervicalInterVertebralDiscSpace && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected disc spaces:</div>
                    {renderDiscSpaceCheckboxes('CervicalInterVertebralDiscSpace', discLevels)}
                  </div>
                )}
              </div>
            )}

            {/* Fracture */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input 
                type="checkbox" 
                checked={formData.CervicalFracture} 
                onChange={() => handleCheckboxChange('CervicalFracture')} 
                className="w-5 h-5 accent-blue-600" 
              />
              <span>Fracture?</span>
            </label>

            {formData.CervicalFracture && (
              <div className="ml-8 space-y-4 border-l-2 border-gray-200 pl-6">
                {/* Compression Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalCompressionFracture} 
                    onChange={() => handleCheckboxChange('CervicalCompressionFracture')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Compression Fracture?</span>
                </label>
                {formData.CervicalCompressionFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalCompressionFracture', fractureLevels)}
                    <label className="flex items-center gap-2 cursor-pointer mt-2">
                      <input 
                        type="checkbox" 
                        checked={formData.CervicalRetropulsion1} 
                        onChange={() => handleCheckboxChange('CervicalRetropulsion1')} 
                        className="w-4 h-4 accent-blue-600" 
                      />
                      <span>Retropulsion?</span>
                    </label>
                  </div>
                )}

                {/* Burst Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalBurstFracture} 
                    onChange={() => handleCheckboxChange('CervicalBurstFracture')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Burst Fracture?</span>
                </label>
                {formData.CervicalBurstFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalBurstFracture', fractureLevels)}
                    <label className="flex items-center gap-2 cursor-pointer mt-2">
                      <input 
                        type="checkbox" 
                        checked={formData.CervicalRetropulsion2} 
                        onChange={() => handleCheckboxChange('CervicalRetropulsion2')} 
                        className="w-4 h-4 accent-blue-600" 
                      />
                      <span>Retropulsion?</span>
                    </label>
                  </div>
                )}

                {/* Chance Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalChanceFracture} 
                    onChange={() => handleCheckboxChange('CervicalChanceFracture')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Chance Fracture?</span>
                </label>
                {formData.CervicalChanceFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalChanceFracture', fractureLevels)}
                    <label className="flex items-center gap-2 cursor-pointer mt-2">
                      <input 
                        type="checkbox" 
                        checked={formData.CervicalRetropulsion3} 
                        onChange={() => handleCheckboxChange('CervicalRetropulsion3')} 
                        className="w-4 h-4 accent-blue-600" 
                      />
                      <span>Retropulsion?</span>
                    </label>
                  </div>
                )}

                {/* Flexion Tear Drop Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalFlexionTearDropFracture} 
                    onChange={() => handleCheckboxChange('CervicalFlexionTearDropFracture')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Flexion Tear Drop fracture?</span>
                </label>
                {formData.CervicalFlexionTearDropFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalFlexionTearDropFracture', fractureLevels)}
                  </div>
                )}

                {/* Extension Tear Drop Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalExtensionTearDropFracture} 
                    onChange={() => handleCheckboxChange('CervicalExtensionTearDropFracture')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Extension tear drop fracture?</span>
                </label>
                {formData.CervicalExtensionTearDropFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalExtensionTearDropFracture', fractureLevels)}
                  </div>
                )}

                {/* Dens Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalDonsFrature} 
                    onChange={() => handleCheckboxChange('CervicalDonsFrature')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Dens Fracture?</span>
                </label>
                {formData.CervicalDonsFrature && (
                  <div className="ml-4 flex gap-6">
                    {densFractureTypes.map(type => (
                      <label key={type} className="flex items-center gap-2 cursor-pointer">
                        <input 
                          type="radio" 
                          checked={formData.CervicalDonsFratureType === type} 
                          onChange={() => handleRadioChange('CervicalDonsFratureType', type)} 
                          className="w-4 h-4" 
                        />
                        <span>{type}</span>
                      </label>
                    ))}
                  </div>
                )}

                {/* Spinous Process Fracture */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalSpinousProcessFracture} 
                    onChange={() => handleCheckboxChange('CervicalSpinousProcessFracture')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Spinous Process fracture?</span>
                </label>
                {formData.CervicalSpinousProcessFracture && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalSpinousProcessFracture', fractureLevels)}
                  </div>
                )}
              </div>
            )}

            {/* Spondylolisthesis */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input 
                type="checkbox" 
                checked={formData.CervicalSpondylolisthesis} 
                onChange={() => handleCheckboxChange('CervicalSpondylolisthesis')} 
                className="w-5 h-5 accent-blue-600" 
              />
              <span>Spondylolisthesis?</span>
            </label>

            {formData.CervicalSpondylolisthesis && (
              <div className="ml-8 space-y-4 border-l-2 border-gray-200 pl-6">
                {/* Retrolisthesis */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalretrolisthesisOf} 
                    onChange={() => handleCheckboxChange('CervicalretrolisthesisOf')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Retrolisthesis?</span>
                </label>
                {formData.CervicalretrolisthesisOf && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected levels:</div>
                    {renderVertebraCheckboxes('CervicalretrolisthesisOf', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10', 'C11'])}
                    <label className="flex items-center gap-2 cursor-pointer mt-2">
                      <input 
                        type="checkbox" 
                        checked={formData.RetroSpondylosis} 
                        onChange={() => handleCheckboxChange('RetroSpondylosis')} 
                        className="w-4 h-4 accent-blue-600" 
                      />
                      <span>With Spondylosis?</span>
                    </label>
                  </div>
                )}

                {/* Anterolisthesis */}
                <label className="flex items-center gap-2 cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={formData.CervicalanterolisthesisOf} 
                    onChange={() => handleCheckboxChange('CervicalanterolisthesisOf')} 
                    className="w-4 h-4 accent-blue-600" 
                  />
                  <span>Anterolisthesis?</span>
                </label>
                {formData.CervicalanterolisthesisOf && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected levels:</div>
                    {renderVertebraCheckboxes('CervicalanterolisthesisOf', ['C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10', 'C11'])}
                    <label className="flex items-center gap-2 cursor-pointer mt-2">
                      <input 
                        type="checkbox" 
                        checked={formData.AntroSpondylosis} 
                        onChange={() => handleCheckboxChange('AntroSpondylosis')} 
                        className="w-4 h-4 accent-blue-600" 
                      />
                      <span>With Spondylosis?</span>
                    </label>
                  </div>
                )}
              </div>
            )}

            {/* Facet Joint Dislocation */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input 
                type="checkbox" 
                checked={formData.CervicalFacetJointDislocationFrature} 
                onChange={() => handleCheckboxChange('CervicalFacetJointDislocationFrature')} 
                className="w-5 h-5 accent-blue-600" 
              />
              <span>Facet Joint Dislocation?</span>
            </label>

            {formData.CervicalFacetJointDislocationFrature && (
              <div className="ml-8 space-y-4 border-l-2 border-gray-200 pl-6">
                <div className="flex gap-6">
                  {facetJointTypes.map(type => (
                    <label key={type} className="flex items-center gap-2 cursor-pointer">
                      <input 
                        type="radio" 
                        checked={formData.CervicalFacetJointDislocationFratureType === type} 
                        onChange={() => handleRadioChange('CervicalFacetJointDislocationFratureType', type)} 
                        className="w-4 h-4" 
                      />
                      <span>{type}</span>
                    </label>
                  ))}
                </div>
                {formData.CervicalFacetJointDislocationFratureType && (
                  <div className="ml-4">
                    <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                    {renderVertebraCheckboxes('CervicalFacetJointDislocationFrature', vertebralLevels)}
                  </div>
                )}
              </div>
            )}

            {/* Osteopenia */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input 
                type="checkbox" 
                checked={formData.CerivicalOsteopenia} 
                onChange={() => handleCheckboxChange('CerivicalOsteopenia')} 
                className="w-5 h-5 accent-blue-600" 
              />
              <span>Osteopenia?</span>
            </label>

            {/* Collapse */}
            <label className="flex items-center gap-2 cursor-pointer">
              <input 
                type="checkbox" 
                checked={formData.CervicalCollapse} 
                onChange={() => handleCheckboxChange('CervicalCollapse')} 
                className="w-5 h-5 accent-blue-600" 
              />
              <span>Collapse?</span>
            </label>

            {formData.CervicalCollapse && (
              <div className="ml-8">
                <div className="text-sm text-gray-600 mb-2">Select affected vertebrae:</div>
                {renderVertebraCheckboxes('CervicalCollapse', vertebralLevels)}
              </div>
            )}

            {/* Additional Findings */}
            <div className="mt-6">
              <label className="block text-gray-600 mb-2">Additional Findings</label>
              <textarea 
                value={formData.CervicalText} 
                onChange={(e) => handleInputChange('CervicalText', e.target.value)} 
                className="w-full px-3 py-2 border rounded" 
                rows="3" 
                placeholder="Enter any additional findings..." 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}